function BannerOrgBillingCtrl($scope, onboardingService, $sce, $state, $stateParams) {
  const trialDaysLeft = onboardingService.getCurrentOrganizationTrialDaysLeft();
  const accountBillingHref = $state.href('app.organization.settings.billing');
  const cameFromSignup = !!$stateParams.signedUp;
  const accountLocked = !!$stateParams.accountLocked;

  const TRIAL_INFO_MESSAGE = `You have <strong>${trialDaysLeft}</strong> days left in your 30 trial. Click <a href="${accountBillingHref}">here</a> to update your credit card.`;
  const TRIAL_WARN_MESSAGE = `You have just <strong>${trialDaysLeft}</strong> days left in your 30 trial. Click <a href="${accountBillingHref}">here</a> to update your credit card.`;
  const TRIAL_WARN_1DAY_MESSAGE = `You have just <strong>${trialDaysLeft}</strong> day left in your 30 trial. Click <a href="${accountBillingHref}">here</a> to update your credit card.`;
  const PAST_DUE_MESSAGE = `Your account is past due. Click <a href="${accountBillingHref}">here</a> to add a credit card to avoid having your account locked.`;

  $scope.showBanner = !cameFromSignup && !accountLocked;

  // Check organization billing status and set banner based on current state
  if (onboardingService.isCurrentOrganizationInTrialMode()) {

    if (trialDaysLeft > 5) {
      $scope.bannerClass = 'banner-info';
      $scope.bannerText = TRIAL_INFO_MESSAGE;
    } else if (trialDaysLeft <= 5 && trialDaysLeft >= 1) {
      $scope.bannerClass = 'banner-warning';
      $scope.bannerText = trialDaysLeft <= 5 && trialDaysLeft !== 1 ? TRIAL_WARN_MESSAGE : TRIAL_WARN_1DAY_MESSAGE;
    } else {
      $scope.bannerClass = 'banner-error';
      $scope.bannerText = PAST_DUE_MESSAGE;
    }
  } else if (onboardingService.isCurrentOrganizationPastDue()) {
    $scope.bannerClass = 'banner-error';
    $scope.bannerText = PAST_DUE_MESSAGE;
  } else {
    $scope.showBanner = false;
  }

  $scope.bannerText = $sce.trustAsHtml($scope.bannerText);
}

BannerOrgBillingCtrl.$inject = [
  '$scope',
  'onboardingService',
  '$sce',
  '$state',
  '$stateParams'
];

export default BannerOrgBillingCtrl;



// WEBPACK FOOTER //
// ./src/directives/bannerOrgBilling/controller.js